import * as React from "react";
import type { SVGProps } from "react";
const SvgDocumentsFileCheckmark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    fill="none"
    viewBox="0 0 25 24" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M16.752 22.004a4.502 4.502 0 1 1 0-9.005 4.502 4.502 0 0 1 0 9.005"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M18.253 9.999V7.826c0-.53-.211-1.04-.587-1.414l-2.829-2.83a2 2 0 0 0-1.414-.586H6.248a2 2 0 0 0-2.001 2v14.007a2 2 0 0 0 2 2h4.002"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M18.253 7.998H14.25a1 1 0 0 1-1-1V2.996M18.41 16.672l-2.073 2.073-1.243-1.245"
    />
  </svg>
);
export default SvgDocumentsFileCheckmark;
